import _styled from "@emotion/styled-base";
import { css } from "@emotion/core";
import shouldForwardProp from "@styled-system/should-forward-prop";
import * as React from "react";
import { createPortal } from "react-dom";
import { position } from "styled-system";
import { remRhythm } from "../css";
import { useContainerElement } from "../hooks";
import ToastManager from "./ToastManager";
import { jsx as ___EmotionJSX } from "@emotion/core";

var StyledToastPortal = /*#__PURE__*/_styled("div", {
  shouldForwardProp: shouldForwardProp,
  target: "e5omxw40"
})(function (_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/css("max-width:", remRhythm(35), ";margin:0 auto;top:0;left:0;right:0;position:fixed;z-index:", theme.zIndices.toast, ";pointer-events:none;");
}, position);

export default function ToastPortal(props) {
  var container = useContainerElement("data-toast-portal");
  if (container == null) return null;
  return createPortal(___EmotionJSX(StyledToastPortal, props, ___EmotionJSX(ToastManager, null)), container);
}